import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';

const Props = {
  titlePublished: PropTypes.string,
  showTitle: PropTypes.bool,
};

const DefaultProps = {
  titlePublished: 'Published by:',
  showTitle: true,
};

export default function PublishedSection({ titlePublished, showTitle }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box py={4} className={classes.publishedBySection}>
        {showTitle && <Typography className={classes.title}>{titlePublished}</Typography>}

        <Box>
          <img
            src="/images/europe-pmc-logo.webp"
            loading="lazy"
            alt="Europe PMC logo"
            width={214}
            height={50}
          />

          <img
            src="/images/frontiers-logo.webp"
            loading="lazy"
            alt="Frontiers logo"
            width={177}
            height={50}
          />
        </Box>

        <Box>
          <img
            src="/images/cellpress-logo.webp"
            loading="lazy"
            alt="Cellpress logo"
            width={172}
            height={50}
          />

          {/* <img
            src="/images/elsevier-logo.webp"
            loading="lazy"
            alt="Elsevier logo"
            width={139}
            height={50}
          /> */}

          <img
            src="/images/science-aaas-logo.webp"
            loading="lazy"
            alt="Science AAAS logo"
            width={114}
            height={50}
          />
        </Box>

        <Box>
          <img
            src="/images/springer-nature-logo.webp"
            loading="lazy"
            alt="Springer nature logo"
            width={118}
            height={50}
          />

          <img src="/images/nih-logo.webp" loading="lazy" alt="NIH logo" width={52} height={50} />
        </Box>
      </Box>
    </LazyLoad>
  );
}

PublishedSection.propTypes = Props;
PublishedSection.defaultProps = DefaultProps;
